import { useMemo, useState, useEffect } from 'react';
import { Card, Col, Row, Button } from 'react-bootstrap';
import Alert from 'react-bootstrap/Alert';
import PageTitle from '../../../includes/PageTitle';
import Tables from '../../../components/Tables/Tables';
import Modals from '../../../components/Modals/Modals';
import Loader from '../../../components/Loader/Loader';
import SelectFild from '../../../components/SelectFild/SelectFild';
import { useFormik } from 'formik';
import { ToastContainer, toast } from 'react-toastify';
import { postCommonMaster, postProjectCategory, getProjectCategoryDetails, postProjectCategorySave, deleteProjectCategory } from '../../../apiservices/ApiServices';

const ProjectCategory = () => {
    const [show, setShow] = useState(false);
    const [isLoading, setLoading] = useState(true);
    const [isLoadings, setLoadings] = useState(false);
    const [addModal, setAddModal] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [data, setData] = useState([]);
    const [commonMaster, setCommonMaster] = useState([]);

    const [selectedClientCentricObjects, setSelectedClientCentricObjects] = useState([]);
    const [selectedBillingCentricObjects, setSelectedBillingCentricObjects] = useState([]);

    const postProjectCategorys = async (postData) => {
        setLoading(true);
        try {
            const res = await postProjectCategory(postData);
            const formattedData = res?.data?.data?.records.map(item => ({
                id: item?.proj_category_id,
                name: item?.proj_category_name,
                categoryCount: item?.category_count,
                subCategoryCount: item?.sub_category_count,
                productCount: item?.product_count,
            }));
            setData(formattedData);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            toast.error(error.response?.data?.message || "Error submitting data");
        }
    };

    const postUpdates = async () => {
        let postData = {
            length: 100
        }
        try {
            const res = await postProjectCategory(postData);
            const formattedData = res?.data?.data?.records.map(item => ({
                id: item?.proj_category_id,
                name: item?.proj_category_name,
                categoryCount: item?.category_count,
                subCategoryCount: item?.sub_category_count,
                productCount: item?.product_count,
            }));
            setData(formattedData);

        } catch (error) {
            toast.error(error.response?.data?.message || "Error submitting data");
        }
    };

    useEffect(() => {
        let postData = {
            length: 100
        }
        postProjectCategorys(postData);
    }, []);

    const addnew = async () => {
        formik.resetForm();
        setLoadings(true);
        setIsEdit(false);
        let postData = {
            type: [
                "client_centric",
                "billing_entity_centric"
            ],
            org_type_code: ''
        }
        try {
            const res = await postCommonMaster(postData);
            setCommonMaster(res.data.data);
            setLoadings(false);
            setAddModal(true);
        } catch (error) {
            setLoadings(false);
            toast.error(error.response?.data?.message || "Error submitting data");
        }
    };

    const columns = useMemo(
        () => [
            {
                Header: "Project Category Name",
                accessor: "name",
            },
            {
                Header: "Category Count",
                accessor: "categoryCount",
            },
            {
                Header: "Sub Category Count",
                accessor: "subCategoryCount",
            },
            {
                Header: "Product Count",
                accessor: "productCount",
            },
            {
                Header: "Action",
                accessor: "action",
                disableSortBy: true,
            },
        ],
        []
    );

    const actions = ['edit', 'delete']
    const subActions = []

    const initialValues = {
        id: '',
        name: '',
        description: '',
        clientCentricIds: [],
        billingEntityCentricIds: [],
    }

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: '',
        onSubmit: async (values) => {
            setLoadings(true);

            const clientCentricIds = selectedClientCentricObjects.map(obj => ({
                id: obj.id,
                is_multiple: obj.is_multiple ? 1 : 0
            }));

            const billingEntityCentricIds = selectedBillingCentricObjects.map(obj => ({
                id: obj.id,
                is_multiple: obj.is_multiple ? 1 : 0
            }));

            let postData;

            if (isEdit) {
                postData = {
                    proj_category_id: values.id,
                    proj_category_name: values.name,
                    proj_category_description: values.description || "",
                    client_centric_ids: clientCentricIds,
                    billing_entity_centric_ids: billingEntityCentricIds
                };
            }
            else {
                postData = {
                    proj_category_name: values.name,
                    proj_category_description: values.description || "",
                    client_centric_ids: clientCentricIds,
                    billing_entity_centric_ids: billingEntityCentricIds
                };
            }



            try {
                const res = await postProjectCategorySave(postData);
                toast.success(res.data.message);
                postUpdates();
                setLoadings(false);
                setIsEdit(false);
                setAddModal(false);
                formik.resetForm();
            } catch (error) {
                setLoadings(false);
                toast.error(error.response?.data?.message || "Error submitting data");
            }
        },
    });
    const { values, handleChange, handleBlur, handleSubmit, setFieldValue, errors, touched } = formik;

    useEffect(() => {
        if (commonMaster?.client_centric) {
            setSelectedClientCentricObjects(prev => {
                const newIds = values.clientCentricIds || [];
                // Build objects from commonMaster for the selected IDs
                const newObjects = newIds.map(id => {
                    const item = commonMaster.client_centric.find(c => c.id === id);
                    if (!item) return null;
                    // Preserve is_multiple from previous state if it exists
                    const existing = prev.find(p => p.id === id);
                    return {
                        ...item,
                        is_multiple: existing ? existing.is_multiple : false
                    };
                }).filter(Boolean);
                return newObjects;
            });
        } else if (!values.clientCentricIds?.length) {
            // If no IDs selected, clear the table
            setSelectedClientCentricObjects([]);
        }
    }, [values.clientCentricIds, commonMaster?.client_centric]);

    useEffect(() => {
        if (commonMaster?.billing_entity_centric) {
            setSelectedBillingCentricObjects(prev => {
                const newIds = values.billingEntityCentricIds || [];
                const newObjects = newIds.map(id => {
                    const item = commonMaster.billing_entity_centric.find(b => b.id === id);
                    if (!item) return null;
                    const existing = prev.find(p => p.id === id);
                    return {
                        ...item,
                        is_multiple: existing ? existing.is_multiple : false
                    };
                }).filter(Boolean);
                return newObjects;
            });
        } else if (!values.billingEntityCentricIds?.length) {
            setSelectedBillingCentricObjects([]);
        }
    }, [values.billingEntityCentricIds, commonMaster?.billing_entity_centric]);

    const handleConfirm = () => {
        setAddModal(false);
        setIsEdit(false);
        formik.resetForm();
    };

    const handleEdit = async (rowData) => {
        setLoadings(true);
        let postData = {
            type: [
                "client_centric",
                "billing_entity_centric"
            ],
            org_type_code: ''
        }
        try {
            const resp = await postCommonMaster(postData);
            setCommonMaster(resp.data.data);

            try {
                const res = await getProjectCategoryDetails(rowData?.id);
                setFieldValue('id', res.data?.data?.proj_category_id);
                setFieldValue('name', res.data?.data?.proj_category_name);
                setFieldValue('description', res.data?.data?.proj_category_description);

                const clientCentricIds = res.data?.data?.client_centric?.map(item => item.id) || [];
                const billingEntityCentricIds = res.data?.data?.billing_entity_centric?.map(item => item.id) || [];

                setFieldValue('clientCentricIds', clientCentricIds);
                setFieldValue('billingEntityCentricIds', billingEntityCentricIds);

                setSelectedClientCentricObjects([]);
                setSelectedBillingCentricObjects([]);

                setIsEdit(true);
                setLoadings(false);
                setAddModal(true);

                setSelectedClientCentricObjects(res.data?.data?.client_centric);
                setSelectedBillingCentricObjects(res.data?.data?.billing_entity_centric);

            } catch (error) {
                setLoadings(false);
                setIsEdit(false);
            }

        } catch (error) {
            setLoadings(false);
            toast.error(error.response?.data?.message || "Error submitting data");
        }
    };

    const handleDelete = (rowData) => {
        setShow(true);
        setFieldValue('id', rowData?.id);
        setFieldValue('name', rowData?.name);
    };

    const handleDeleteCon = async () => {
        setLoadings(true);
        try {
            const res = await deleteProjectCategory(values.id);
            toast.success(res.data.message);
            setLoadings(false);
            setShow(false);
            postUpdates();
            setFieldValue('id', '');
            setFieldValue('name', '');
        } catch (error) {
            setLoadings(false);
            setShow(false);
        }
    };

    return (
        <>
            <ToastContainer
                position="top-right"
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                style={{ zIndex: 9999999999, position: 'fixed' }}
            />

            {isLoading ? <Loader /> :
                <>
                    <PageTitle titles="Project Category" active="Project Category" items={['Home']} />
                    <Row>
                        <Col sm={12} className="col-12">
                            <Card>
                                <Card.Body className="example1-table">
                                    <div className='custompageHed'>
                                        <Row>
                                            <Col md={6}>
                                                <div className='pagetitle_hed'>
                                                    <h1>Project Category</h1>
                                                </div>
                                            </Col>
                                            <Col md={6}>
                                                <div className='w-100 d-flex justify-content-end'>
                                                    <button type='button' className='btn btn-primary' onClick={() => addnew()}>Add New</button>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                    <Tables
                                        columns={columns}
                                        data={data}
                                        actions={actions}
                                        subActions={subActions}
                                        onEdit={handleEdit}
                                        onDelete={handleDelete}
                                    />
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </>
            }

            <Modals
                show={addModal}
                handleClose={() => setAddModal(false)}
                title={isEdit ? 'Edit Project Category' : "Add New"}
                textColor='#000'
                size='xl'
                centered={true}
                backdrop={true}
                onConfirm={handleConfirm}
            >
                <form onSubmit={handleSubmit} autoComplete="off">
                    <Row>
                        <Col md={6}>
                            <div className="form-group">
                                <label className="form-label">Project Category Name</label>
                                <input
                                    type='text'
                                    id="name"
                                    name="name"
                                    className="form-control"
                                    autoComplete='off'
                                    value={values.name}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                {errors.name && touched.name && (
                                    <p className="errormsg">{errors.name}</p>
                                )}
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className="form-group">
                                <label className="form-label">Project Codeategory Description</label>
                                <input
                                    type='text'
                                    id="description"
                                    name="description"
                                    className="form-control"
                                    autoComplete='off'
                                    value={values.description}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                {/* <textarea
                                    type='text'
                                    id="description"
                                    name="description"
                                    className="form-control"
                                    autoComplete='off'
                                    value={values.description}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                /> */}
                                {errors.description && touched.description && (
                                    <p className="errormsg">{errors.description}</p>
                                )}
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className="form-group">
                                <label className="form-label">Select Client Centric Role</label>
                                <SelectFild
                                    Firstop='Select Client Centric Role'
                                    selectName='clientCentricIds'
                                    options={commonMaster?.client_centric}
                                    value={values.clientCentricIds}
                                    onChange={(selectedOptions) => {
                                        const selectedValues = selectedOptions ?
                                            Array.isArray(selectedOptions) ?
                                                selectedOptions.map(option => option.value) :
                                                selectedOptions.value :
                                            [];
                                        setFieldValue('clientCentricIds', selectedValues);
                                    }}
                                    onBlur={() => handleBlur('clientCentricIds')}
                                    isMulti={true}
                                />
                                {errors.clientCentricIds && touched.clientCentricIds && (
                                    <p className="errormsg">{errors.clientCentricIds}</p>
                                )}
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className="form-group">
                                <label className="form-label">Select Billing Entity Centric Role</label>
                                <SelectFild
                                    Firstop='Select Billing Entity Centric Role'
                                    selectName='billingEntityCentricIds'
                                    options={commonMaster?.billing_entity_centric}
                                    value={values.billingEntityCentricIds}
                                    onChange={(selectedOptions) => {
                                        const selectedValues = selectedOptions ?
                                            Array.isArray(selectedOptions) ?
                                                selectedOptions.map(option => option.value) :
                                                selectedOptions.value :
                                            [];
                                        setFieldValue('billingEntityCentricIds', selectedValues);
                                    }}
                                    onBlur={() => handleBlur('billingEntityCentricIds')}
                                    isMulti={true}
                                />
                                {errors.billingEntityCentricIds && touched.billingEntityCentricIds && (
                                    <p className="errormsg">{errors.billingEntityCentricIds}</p>
                                )}
                            </div>
                        </Col>
                        <Col md={6}>
                            {selectedClientCentricObjects.length > 0 && (
                                <div className="fieldsets mainFS">
                                    <div className='fieldsetsboxs'>
                                        <h6>Selected Client Centric Role</h6>
                                    </div>
                                    <div className='formsBox'>
                                        <table className="table">
                                            <thead>
                                                <tr>
                                                    <th>Name</th>
                                                    <th style={{ width: 100 }}>Is Multiple</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {selectedClientCentricObjects.map(obj => (
                                                    <tr key={obj.id}>
                                                        <td>{obj.name}</td>
                                                        <td>
                                                            <div className="switchs" style={{ display: 'block', margin: '0 auto' }}>
                                                                <input
                                                                    type="checkbox"
                                                                    id={`swi_${obj.id}`}
                                                                    className="form-control"
                                                                    autoComplete="off"
                                                                    checked={obj.is_multiple || false}
                                                                    onChange={(e) => {
                                                                        setSelectedClientCentricObjects(prev =>
                                                                            prev.map(item =>
                                                                                item.id === obj.id
                                                                                    ? { ...item, is_multiple: e.target.checked }
                                                                                    : item
                                                                            )
                                                                        );
                                                                    }}
                                                                />
                                                                <span className="slider round"></span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            )}
                        </Col>
                        <Col md={6}>
                            {selectedBillingCentricObjects.length > 0 && (
                                <div className="fieldsets mainFS">
                                    <div className='fieldsetsboxs'>
                                        <h6>Selected Billing Entity Centric Role</h6>
                                    </div>
                                    <div className='formsBox'>
                                        <table className="table">
                                            <thead>
                                                <tr>
                                                    <th>Name</th>
                                                    <th style={{ width: 100 }}>Is Multiple</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {selectedBillingCentricObjects.map(obj => (
                                                    <tr key={obj.id}>
                                                        <td>{obj.name}</td>
                                                        <td>
                                                            <div className="switchs" style={{ display: 'block', margin: '0 auto' }}>
                                                                <input
                                                                    type="checkbox"
                                                                    id={`swi_${obj.id}`}
                                                                    className="form-control"
                                                                    autoComplete="off"
                                                                    checked={obj.is_multiple || false}
                                                                    onChange={(e) => {
                                                                        setSelectedBillingCentricObjects(prev =>
                                                                            prev.map(item =>
                                                                                item.id === obj.id
                                                                                    ? { ...item, is_multiple: e.target.checked }
                                                                                    : item
                                                                            )
                                                                        );
                                                                    }}
                                                                />
                                                                <span className="slider round"></span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            )}
                        </Col>
                    </Row>
                    <div className='modalfooters'>
                        <div className='button-boxs grid'>
                            <button type='submit' className='btn btn-primary'>{isEdit ? "Update" : 'Save'}</button>
                            <button type='button' onClick={handleConfirm} className='btn btn-default'>Cancel</button>
                        </div>
                    </div>
                </form>
            </Modals>

            {show ? (<>
                <Alert variant="danger" onClose={() => setShow(false)} dismissible>
                    <Alert.Heading>Are you sure want to Delete <span>{values.name}</span> Project Category ?</Alert.Heading>
                    <hr />
                    <div className='button-boxs grid'>
                        <div>
                            <button onClick={() => handleDeleteCon()} className='btn btn-primary'>OK</button>
                        </div>
                        <div>
                            <button onClick={() => setShow(false)} className='btn btn-default'>Cancel</button>
                        </div>
                    </div>
                </Alert>
                <div className='overly'></div>
            </>) : null}
            {isLoadings && <Loader />}
        </>
    )
}

export default ProjectCategory